import { FieldProps } from "formik";
import { isEmpty } from "lodash";
import Select from "react-select";
import {portalMenu} from "../ui";

interface Option {
  label: string;
  value: string;
}

interface CustomSelectProps extends FieldProps {
  id: string;
  options: any;
  type?: string;
  value?: string;
  error?: string;
  label?: string;
  isMulti?: boolean;
  touched?: boolean;
  className?: string;
  placeholder?: string;
  buttonOption?: string;
  onClickOption?: () => void;
  onChangeItem?: (option: any) => void;
}

export const CustomSelect = ({
  id,
  form,
  type,
  label,
  error,
  field,
  value,
  options,
  touched,
  placeholder,
  buttonOption,
  isMulti = false,
  onChangeItem,
  onClickOption,
}: CustomSelectProps) => {
 
  const onChange = (option: any) => {
    if (type === "UNIT" && onChangeItem) {
      onChangeItem(option);
    } else {
      form.setFieldValue(
        field.name,
        isMulti
          ? (option as Option[]).map((item: Option) => item.value)
          : (option as Option).value
      );
    }
  };

  const getValue = () => {
    if (options) {
      if (type === "UNIT") {
        return options.find((option: any) => option.value === value);
      } else {
        return isMulti
          ? options.filter(
              (option: any) => field.value.indexOf(option.value) >= 0
            )
          : options.find((option: any) => option.value === field.value);
      }
    } else {
      return isMulti ? [] : ("" as any);
    }
  };

  // Token colours so react-select matches .nl-input / .nl-select and follows
  // dark mode.
  const customStyles = {
    control: (base: any, state: any) => ({
      ...base,
      minHeight: 40,
      borderRadius: 10,
      backgroundColor: "var(--surface)",
      borderColor: state.isFocused ? "var(--brand)" : "var(--border2)",
      boxShadow: state.isFocused ? "0 0 0 3px var(--brandSoft)" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "var(--brand)" : "var(--border2)",
      },
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 30,
      borderRadius: 10,
      overflow: "hidden",
      backgroundColor: "var(--surface)",
      border: "1px solid var(--border)",
      boxShadow: "var(--shadowLg)",
    }),
    option: (base: any, state: any) => ({
      ...base,
      fontSize: 14,
      color: state.isSelected ? "#fff" : "var(--text)",
      backgroundColor: state.isSelected
        ? "var(--brand)"
        : state.isFocused
        ? "var(--surface2)"
        : "transparent",
    }),
    singleValue: (base: any) => ({ ...base, color: "var(--text)" }),
    input: (base: any) => ({ ...base, color: "var(--text)" }),
    placeholder: (base: any) => ({ ...base, color: "var(--text3)" }),
    multiValue: (base: any) => ({
      ...base,
      borderRadius: 6,
      backgroundColor: "var(--brandSoft)",
    }),
    multiValueLabel: (base: any) => ({ ...base, color: "var(--brand)" }),
    indicatorSeparator: () => ({ display: "none" }),
    dropdownIndicator: (base: any) => ({ ...base, color: "var(--text3)" }),
  };

  return (
    <div className="w-full">
      <div className="w-full flex flex-row items-center justify-between">
        {label && (
          <label
            htmlFor={id}
            className="mb-2 block text-sm font-medium text-valhalla"
          >
            {label}
          </label>
        )}
        {buttonOption && (
          <div
            onClick={onClickOption}
            className="inline-flex cursor-pointer justify-center mb-2 text-sm font-medium text-medium-slate-blue underline hover:text-slate-blue"
          >
            {buttonOption}
          </div>
        )}
      </div>

      <div className="w-full relative flex flex-row">
        <Select
          name={field.name}
          options={options}
          isMulti={isMulti}
          value={getValue()}
          onChange={onChange}
          {...portalMenu(customStyles)}
          placeholder={placeholder}
          className={"block w-full outline-none text-sm"}
        />
      </div>
      {!isEmpty(error) && touched && (
        <span className="mt-1 first-line:block text-xs font-normal text-rose-400	">
          {error}
        </span>
      )}
    </div>
  );
};
export default CustomSelect;
